import React, { useEffect, useState } from "react";
import PageWrapper from "../../Components/PageWrapper";
import Layout from "../../Layout/Layout";
import { useLocation } from "react-router-dom";
import RenewalList from "./RenewalList";

export default function CustomersRenewalList(props) {
    const location = useLocation();
    const [navPath, setNavPath] = useState('');
    const [activeTab, setActiveTab] = useState("notCompleted");

    useEffect(() => {
        if (location.pathname.toLowerCase().indexOf('new') > 0) {
            setNavPath('new');
        } else if (location.pathname.toLowerCase().indexOf('details') > 0) {
            setNavPath('details');
        } else if (location.pathname.toLowerCase().indexOf('renewallist') > 0) {
            setNavPath('renewallist');
        } else {
            setNavPath('list');
        }
    }, [location]);

    return (
        <Layout>
            <PageWrapper>
                <div>
                    {/* Tab Navigation */}
                    <div className="text-center bg-white p-2 m-1 shadow-sm rounded">
                        <div className="row align-items-center">
                            <div className="col-md-9">
                                <ul className="nav nav-pills">
                                    <li className="nav-item">
                                        <button
                                            className={`nav-link ${activeTab === "notCompleted" ? "active" : ""}`}
                                            onClick={() => setActiveTab("notCompleted")}
                                        >
                                            Renewal Calls Not Completed
                                        </button>
                                    </li>
                                    <li className="nav-item">
                                        <button
                                            className={`nav-link ${activeTab === "completed" ? "active" : ""}`}
                                            onClick={() => setActiveTab("completed")}
                                        >
                                            Renewal Calls Completed
                                        </button>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-md-3 text-end">
                                <span className="badge bg-label-secondary px-3 py-2" style={{ fontSize: '0.85rem' }}>
                                    {activeTab === "notCompleted" ? "Not Completed" : "Completed"}
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* RenewalList receives activeTab and re-fetches when it changes */}
                    <RenewalList activeTab={activeTab} />
                </div>
            </PageWrapper>
        </Layout>
    );
}